import { NavLink, useLocation } from "react-router-dom";
import Logo from "./../../assets/images/logo.png";
import Search from "../ui/Search";
import { useDispatch, useSelector } from "react-redux";
import { userLoggedOut } from "../../features/auth/authSlice";

export default function Header() {
    const { user } = useSelector((state) => state.auth);
    const { avatar, name } = user;
    const { pathname } = useLocation();
    const dispatch = useDispatch();

    // logout handler
    const logout = () => {
        dispatch(userLoggedOut());
        localStorage.clear();
    };

    return (
        <>
            <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
                <img src={Logo} className="h-10 w-10" />
                {pathname !== "/teams" && <Search />}
                <div className="ml-10">
                    <NavLink
                        to="/projects"
                        className={({ isActive }) =>
                            `${
                                isActive ? "text-indigo-700" : "text-gray-600"
                            } mx-2 text-sm font-semibold`
                        }
                    >
                        Projects
                    </NavLink>
                    <NavLink
                        to="/teams"
                        className={({ isActive }) =>
                            `${
                                isActive ? "text-indigo-700" : "text-gray-600"
                            } mx-2 text-sm font-semibold`
                        }
                    >
                        Team
                    </NavLink>
                </div>
                <div className="flex items-center ml-auto">
                    <h4 className="text-sm">
                        Hi, <span className="font-bold">{name}</span>
                    </h4>
                    <button className="flex items-center mr-6 ml-3 justify-center overflow-hidden cursor-pointer">
                        <img
                            src={avatar}
                            className="w-8 h-8 object-cover border rounded-full"
                            alt="logo of man"
                        />
                    </button>
                    <button onClick={logout} className="text-red-600">
                        Logout
                    </button>
                </div>
            </div>
        </>
    );
}
